// extracted by mini-css-extract-plugin
module.exports = {"bookshelf":"UserBookshelvesView__bookshelf","bookshelfList":"UserBookshelvesView__bookshelfList"};